import { create } from 'zustand';
import { skillsApi } from './skillsApi';
import type { SkillType } from './skillsApi';

interface SkillSkinState {
  skins: Record<SkillType, string | null>;
  loaded: boolean;
  /** Fetch the global skill skin map once. Safe to call from many icons —
   * concurrent calls share a single in-flight request. */
  load: () => Promise<void>;
  /** Force a refetch (admin preview / after upload). */
  refresh: () => Promise<void>;
}

let inflight: Promise<void> | null = null;

export const useSkillSkins = create<SkillSkinState>((set, get) => {
  const fetchSkins = async () => {
    try {
      const map = await skillsApi.skins();
      set({ skins: { disrupt: map.disrupt ?? null, shield: map.shield ?? null }, loaded: true });
    } catch {
      set({ loaded: true });
    } finally {
      inflight = null;
    }
  };

  return {
    skins: { disrupt: null, shield: null },
    loaded: false,
    load: () => {
      if (get().loaded) return Promise.resolve();
      if (!inflight) inflight = fetchSkins();
      return inflight;
    },
    refresh: () => {
      inflight = fetchSkins();
      return inflight;
    },
  };
});
